import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import styles from './styles.module.css';

const aboutPages = {
  firm: {
    title: 'About the Firm',
    sections: [
      {
        title: 'Overview',
        content:
          'Our firm provides sophisticated legal support to businesses engaged in commercial transactions, corporate deals, and cross-border operations. We combine deep legal knowledge with practical commercial insight to help clients execute transactions efficiently, manage risk, and achieve strategic objectives.',
      },
      {
        title: 'Our Philosophy',
        content:
          'We believe that legal counsel should be both sophisticated and practical. Our goal is to provide clients with actionable advice that supports long-term success, reduces risk, and strengthens the business as a whole.',
      },
    ],
  },
  attorney: {
    title: 'Artur Maiskii — Managing Attorney',
    sections: [
      {
        title: 'Professional Summary',
        content:
          'Artur Maiskii is a corporate and transactional attorney representing businesses, investors, and entrepreneurs across the United States and internationally. His practice focuses on commercial transactions, mergers and acquisitions, corporate governance, and cross-border business expansion.',
      },
      {
        title: 'Areas of Focus',
        content:
          'Corporate & Commercial Transactions • Mergers & Acquisitions • Business Formation & Governance • Contracts & Negotiations • Cross-Border Transactions • Private Investments & Financing • Regulatory & Compliance Support',
      },
    ],
  },
  approach: {
    title: 'Our Approach',
    sections: [
      {
        title: 'Overview',
        content:
          'We provide legal counsel designed to support the full lifecycle of business activity—from formation and governance to transactions and compliance. Our clients appreciate our ability to translate complex legal issues into clear, practical guidance.',
      },
      {
        title: 'Core Principles',
        content:
          'Business-First Thinking • Strategic Execution • Clarity & Communication • Rigorous Risk Management • Efficiency & Responsiveness • Global Perspective',
      },
    ],
  },
};

function AboutPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const page =
    aboutPages[slug as keyof typeof aboutPages] || aboutPages['firm'];

  return (
    <div className={styles.aboutContainer}>
      <div className={styles.heroBanner}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>{page.title}</h1>
        </div>
      </div>

      <div className={styles.contentSection}>
        <Row gutter={[60, 40]}>
          <Col xs={24} lg={16}>
            <div className={styles.mainContent}>
              {page.sections.map((section, index) => (
                <div key={index} className={styles.section}>
                  <h2 className={styles.sectionTitle}>{section.title}</h2>
                  <p className={styles.sectionContent}>{section.content}</p>
                </div>
              ))}
            </div>
          </Col>

          <Col xs={24} lg={8}>
            <div className={styles.sidebar}>
              <div className={styles.ctaCard}>
                <h3>Ready to Discuss Your Legal Needs?</h3>
                <p>
                  We provide tailored counsel for businesses navigating
                  transactions, contracts, and corporate operations.
                </p>
                <Button
                  type="primary"
                  block
                  size="large"
                  icon={<PhoneOutlined />}
                  className={styles.ctaButton}
                  onClick={() => navigate('/contact')}
                >
                  Schedule Consultation
                </Button>
              </div>

              {slug === 'attorney' && (
                <div className={styles.educationCard}>
                  <h4>Education</h4>
                  <p>Juris Doctor (J.D.)</p>
                  <p>LL.M. in International Business Law</p>
                  <p>Admitted to practice in Washington State</p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default AboutPage;
